// extracted by mini-css-extract-plugin
export default {"siriusPagination":"index-module--siriusPagination--31PDy","siriusTable":"index-module--siriusTable--sbxR+","headerBgColor":"index-module--header-bg-color--jqfo4"};